import { ClientApi, OpenAPIConfig } from "@ns/api";

import { environmentVariables } from "../env/environment-variables.ts";

import { CustomAxiosHttpRequest } from "./custom-axios-client.ts";
import { getSessionToken } from "./token-helper.ts";

const NO_TOKEN = "";
const ACCESS_TOKEN_URL_BLOCKLIST = ["login"];
function urlInBlocklist(url: string) {
  return ACCESS_TOKEN_URL_BLOCKLIST.some((blocklistUrlSegment) =>
    url.includes(blocklistUrlSegment),
  );
}

const config: Partial<OpenAPIConfig> = {
  BASE: environmentVariables.baseApiUrl,
  VERSION: "1",
  TOKEN: async (options) =>
    urlInBlocklist(options.url) ? NO_TOKEN : (getSessionToken() ?? NO_TOKEN),
};

export const api = new ClientApi(config, CustomAxiosHttpRequest);
